import React from "react";
import Layout from "components/layout";
import SEO from "components/seo";
import LanguageTranslationService from "components/languageTranslationService";

function SupportedLanguages() {
  const title = "Language Translation Services";
  const description =
    "Avail now of highly professional, accurate, and fast translation with Tomedes' language translation services.";
  const keywords =
    "language translation services, language translation service, language translation";
  const slug = "/language-translation-service.php";
  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug={slug}
      />
      <LanguageTranslationService />
    </Layout>
  );
}
export default SupportedLanguages;